// import Cookies from "js-cookie";
// import { useState } from "react";
// import InlineSpinner from "../../../components/loading/InlineSpinner";
// import { useFetchData, usePostApiRequest } from "../../../helpers/api";
// import DashboardLayout from "../DashboardLayout";
// import AddModal from "./AddModal";
// import { FaPencil, FaTrash } from "react-icons/fa6";
// import ConfirmationModal from "../../../components/modal/ConfirmationModal";
// import LoadingSpinner from "../../../components/loading/LoadingSpinner";
// import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
// import toast from "react-hot-toast";

// const cookieData = Cookies.get("kalista-web-user");
// const customerData = cookieData ? JSON.parse(cookieData) : null;
// const theKeyId = customerData?.Id ? customerData.Id : null;

// const tableHeadData = ["No.", "Shape", "Size", "PCS", "Weight", "Actions"];

// const defaultFormData = {
//   Id: 0,
//   CustomerId: Number(theKeyId),
//   Shape: "ROUND",
//   Size: "",
//   CaratWeight: "",
//   NumberOfPCS: "",
//   SizeCode: "",
// };
// const itemsPerPage = 10;

// const MyStock = () => {
//   const [stockModal, setStockModal] = useState(false);
//   const [deleteModal, setDeleteModal] = useState(false);
//   const [isLoadingData, setIsLoadingData] = useState(false);
//   const [formData, setFormData] = useState(defaultFormData);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [deleteType, setDeleteType] = useState('');
//   const { data: stockData, isLoading } = useFetchData(
//     "customerStock",
//     "/Customer/GetCustomerStock",
//     { CustomerId: Number(theKeyId) }
//   );
//   const postApiRequest = usePostApiRequest();

//   const openSaveModal = () => {
//     setStockModal(true);
//     setFormData(defaultFormData);
//   };

//   const openEditModal = (stock) => {
//     setFormData(stock);
//     setStockModal(true);
//   };

//   const handleOpenDeleteModal = (id) => {
//     setFormData((prev) => ({
//       ...prev,
//       Id: id,
//     }));
//     setDeleteModal(true);
//   };

//   const deleteReset = () => {
//     // setFormData(defaultFormData);
//     // setDeleteModal(false);
//   };

//   const clearStocks = async () => {
//     setIsLoadingData(true);
//     console.log("delete all stock");
//     const payload = {
//       Id: 0,
//       CustomerId: theKeyId
//     }
//     try {
//       const response = await postApiRequest({
//         url: "/Customer/DeleteCustomerStock",
//         method: "POST",
//         data: payload, //{ CustomerId: theKeyId },
//         queryKey: ["customerStock"],
//       });
//       if (response.Status === true) {
//         // toast.success(response.Message || "All stocks cleared successfully.");
//       } else {
//         toast.error(response.Message || "Failed to clear stocks.");
//       }
//       console.log("Delete All Stocks :", response);

//     } catch (error) {
//       console.error("Clear stock failed:", error);
//       toast.error("An error occurred while clearing stocks.");
//     } finally {
//       setIsLoadingData(false);
//     }
//   }

//   const handleDeleteStock = async () => {
//     setIsLoadingData(true);
//     console.log("delete item");

//     try {
//       const response = await postApiRequest({
//         url: "/Customer/DeleteCustomerStock",
//         method: "POST",
//         data: { Id: formData.Id, CustomerId: theKeyId },
//         queryKey: ["customerStock"],
//       });
//       if (response.Status === true) {
//         deleteReset();
//         // toast.success(response.Message);
//       } else {
//         toast.error(response.Message);
//       }
//     } catch (error) {
//       console.error("API call failed:", error);
//     } finally {
//       setIsLoadingData(false);
//     }
//   };

//   // pagination
//   const totalItems = stockData?.Data?.length || 0;
//   const totalPages = Math.ceil(totalItems / itemsPerPage);
//   const paginatedData = stockData?.Data?.slice(
//     (currentPage - 1) * itemsPerPage,
//     currentPage * itemsPerPage
//   );
//   const nextPage = () => {
//     if (currentPage < totalPages) setCurrentPage(currentPage + 1);
//   };
//   const prevPage = () => {
//     if (currentPage > 1) setCurrentPage(currentPage - 1);
//   };

//   return (
//     <DashboardLayout pageClass="mystock_page">
//       {isLoadingData && <LoadingSpinner />}
//       {isLoading ? (
//         <div className="loading_screen">
//           <InlineSpinner />
//         </div>
//       ) : (
//         <>
//           <div className="dashboard_header">
//             <h5>My Stock</h5>
//             <div className="add_stock_btn_part">
//               <button className="button primary_btn" onClick={() => {
//                 setDeleteType('Clear All Stock');
//                 setDeleteModal(true);
//               }}>
//                 Clear All Stock
//               </button>
//               <button className="button primary_btn" onClick={openSaveModal}>
//                 Add Stock
//               </button>
//             </div>
//           </div>
//           <div className="dashboard_content">
//             <table>
//               <thead>
//                 <tr>
//                   {tableHeadData.map((header, i) => (
//                     <th key={i}>{header}</th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {paginatedData?.map((stock, index) => (
//                   <tr key={index}>
//                     <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
//                     <td>{stock.Shape}</td>
//                     <td>{stock.SizeCode}</td>
//                     <td>{stock.NumberOfPCS}</td>
//                     <td>{stock.CaratWeight}</td>
//                     <td className="action_table_cell" style={{ width: "80px" }}>
//                       <FaPencil
//                         title="Edit"
//                         className="edit_icon"
//                         onClick={() => openEditModal(stock)}
//                       />
//                       <FaTrash
//                         title="Delete"
//                         className="delete_icon"
//                         onClick={() => {
//                           handleOpenDeleteModal(stock.Id)
//                           setDeleteType('delete_icon')
//                         }}
//                       />
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>

//             <div className="customer_stock_pagination">
//               <div className="btn_con">
//                 <button
//                   onClick={prevPage}
//                   disabled={currentPage === 1}
//                   className="pagination_btn prev"
//                 >
//                   <IoIosArrowBack size="20px" />
//                 </button>
//                 <span>{currentPage}</span>
//                 <button
//                   onClick={nextPage}
//                   disabled={currentPage === totalPages}
//                   className="pagination_btn next"
//                 >
//                   <IoIosArrowForward size="20px" />
//                 </button>
//               </div>
//             </div>
//           </div>
//         </>
//       )}

//       {
//         stockModal && (
//           <AddModal
//             show={stockModal}
//             onHide={() => setStockModal(false)}
//             formData={formData}
//             setFormData={setFormData}
//             defaultFormData={defaultFormData}
//           />
//         )
//       }
//       {
//         deleteModal && (
//           <ConfirmationModal
//             show={deleteModal}
//             onHide={() => setDeleteModal(false)}
//             modalTitle="Confirmation"
//             modalText={deleteType === 'Clear All Stock' ? 'Are you sure you want to clear all stocks?' : 'Are you sure you want to delete?'}
//             handleSubmit={deleteType === 'Clear All Stock' ? clearStocks : handleDeleteStock}
//             submitText={deleteType === 'Clear All Stock' ? 'Clear All' : 'Delete'}
//           />
//         )
//       }
//     </DashboardLayout>
//   );
// };

// export default MyStock;





import Cookies from "js-cookie";
import { useState } from "react";
import InlineSpinner from "../../../components/loading/InlineSpinner";
import { useFetchData, usePostApiRequest } from "../../../helpers/api";
import DashboardLayout from "../DashboardLayout";
import AddModal from "./AddModal";
import { FaPencil, FaTrash } from "react-icons/fa6";
import ConfirmationModal from "../../../components/modal/ConfirmationModal";
import LoadingSpinner from "../../../components/loading/LoadingSpinner";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import toast from "react-hot-toast";

const cookieData = Cookies.get("kalista-web-user");
const customerData = cookieData ? JSON.parse(cookieData) : null;
const theKeyId = customerData?.Id ? customerData.Id : null;

const tableHeadData = ["No.", "Shape", "Size", "PCS", "Weight", "Actions"];

// old form handle this is pass in formData state under
// const defaultFormData = {
//   Id: 0,
//   CustomerId: Number(theKeyId),
//   Shape: "ROUND",
//   Size: "",
//   CaratWeight: "",
//   NumberOfPCS: "",
//   SizeCode: "",
// };
const itemsPerPage = 10;

const MyStock = () => {
  const [stockModal, setStockModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [formData, setFormData] = useState([{
    Id: 0,
    CustomerId: Number(theKeyId),
    Shape: "ROUND",
    Size: "",
    CaratWeight: "",
    NumberOfPCS: "",
    SizeCode: "",
  }]);

  const [currentPage, setCurrentPage] = useState(1);
  const [deleteType, setDeleteType] = useState('');
  const { data: stockData, isLoading } = useFetchData(
    "customerStock",
    "/Customer/GetCustomerStock",
    { CustomerId: Number(theKeyId) }
  );
  const postApiRequest = usePostApiRequest();

  const openSaveModal = () => {
    setStockModal(true);
    // setFormData(defaultFormData);
    setFormData(
      [{
        Id: 0,
        CustomerId: Number(theKeyId),
        Shape: "ROUND",
        Size: "",
        CaratWeight: "",
        NumberOfPCS: "",
        SizeCode: "",
      }]
    )
  };

  const openEditModal = (stock) => {
    setFormData([stock]);
    setStockModal(true);
  };

  const handleOpenDeleteModal = (id) => {
    setFormData((prev) => ({
      ...prev,
      Id: id,
    }));
    setDeleteModal(true);
  };

  const deleteReset = () => {
    // setFormData(defaultFormData);
    setFormData(
      [{
        Id: 0,
        CustomerId: Number(theKeyId),
        Shape: "ROUND",
        Size: "",
        CaratWeight: "",
        NumberOfPCS: "",
        SizeCode: "",
      }]
    )
    setDeleteModal(false);
  };

  const clearStocks = async () => {
    setIsLoadingData(true);
    console.log("delete all stock");
    const payload = {
      Id: 0,
      CustomerId: theKeyId
    }
    try {
      const response = await postApiRequest({
        url: "/Customer/DeleteCustomerStock",
        method: "POST",
        data: payload, //{ CustomerId: theKeyId },
        queryKey: ["customerStock"],
      });
      if (response.Status === true) {
        // toast.success(response.Message || "All stocks cleared successfully.");
      } else {
        toast.error(response.Message || "Failed to clear stocks.");
      }
      console.log("Delete All Stocks :", response);
      setDeleteModal(false);
    } catch (error) {
      console.error("Clear stock failed:", error);
      toast.error("An error occurred while clearing stocks.");
    } finally {
      setIsLoadingData(false);
    }
  }

  const handleDeleteStock = async () => {
    setIsLoadingData(true);
    console.log("delete item");

    try {
      const response = await postApiRequest({
        url: "/Customer/DeleteCustomerStock",
        method: "POST",
        data: { Id: formData.Id, CustomerId: theKeyId },
        queryKey: ["customerStock"],
      });
      if (response.Status === true) {
        deleteReset();
        // toast.success(response.Message);
      } else {
        toast.error(response.Message);
      }
    } catch (error) {
      console.error("API call failed:", error);
    } finally {
      setIsLoadingData(false);
    }
  };

  // pagination
  const totalItems = stockData?.Data?.length || 0;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const paginatedData = stockData?.Data?.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  const nextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };
  const prevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  return (
    <DashboardLayout pageClass="mystock_page">
      {isLoadingData && <LoadingSpinner />}
      {isLoading ? (
        <div className="loading_screen">
          <InlineSpinner />
        </div>
      ) : (
        <>
          <div className="dashboard_header">
            <h5>My Stock</h5>
            <div className="add_stock_btn_part">
              <button className="button primary_btn" onClick={() => {
                setDeleteType('Clear All Stock');
                setDeleteModal(true);
              }}>
                Clear All Stock
              </button>
              <button className="button primary_btn" onClick={openSaveModal}>
                Add Stock
              </button>
            </div>
          </div>
          <div className="dashboard_content">
            <table>
              <thead>
                <tr>
                  {tableHeadData.map((header, i) => (
                    <th key={i}>{header}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {paginatedData?.map((stock, index) => (
                  <tr key={index}>
                    <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                    <td>{stock.Shape}</td>
                    <td>{stock.SizeCode}</td>
                    <td>{stock.NumberOfPCS}</td>
                    <td>{stock.CaratWeight}</td>
                    <td className="action_table_cell" style={{ width: "80px" }}>
                      <FaPencil
                        title="Edit"
                        className="edit_icon"
                        onClick={() => openEditModal(stock)}
                      />
                      <FaTrash
                        title="Delete"
                        className="delete_icon"
                        onClick={() => {
                          handleOpenDeleteModal(stock.Id)
                          setDeleteType('delete_icon')
                        }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div className="customer_stock_pagination">
              <div className="btn_con">
                <button
                  onClick={prevPage}
                  disabled={currentPage === 1}
                  className="pagination_btn prev"
                >
                  <IoIosArrowBack size="20px" />
                </button>
                <span>{currentPage}</span>
                <button
                  onClick={nextPage}
                  disabled={currentPage === totalPages}
                  className="pagination_btn next"
                >
                  <IoIosArrowForward size="20px" />
                </button>
              </div>
            </div>
          </div>
        </>
      )}

      {
        stockModal && (
          <AddModal
            show={stockModal}
            onHide={() => setStockModal(false)}
            formData={formData}
            setFormData={setFormData}
          // defaultFormData={defaultFormData}
          />
        )
      }
      {
        deleteModal && (
          <ConfirmationModal
            show={deleteModal}
            onHide={() => setDeleteModal(false)}
            modalTitle="Confirmation"
            modalText={deleteType === 'Clear All Stock' ? 'Are you sure you want to clear all stocks?' : 'Are you sure you want to delete?'}
            handleSubmit={deleteType === 'Clear All Stock' ? clearStocks : handleDeleteStock}
            submitText={deleteType === 'Clear All Stock' ? 'Clear All' : 'Delete'}
          />
        )
      }
    </DashboardLayout>
  );
};

export default MyStock;
